/**
 * Industrial Park — baked by ultra_map_editor. Edit via the editor.
 *
 * Do not hand-edit: this file is regenerated wholesale on the next bake, and
 * hand-written comments/formatting do not survive a bake.
 */
import type { WorldData } from '../../types';

export const map: WorldData = {
  cityName: "Industrial Park",
  ground: { width: 80, depth: 76 },
  spawnPoint: { x: -2, z: 32 },
  groundTexture: { textureUrl: "/textures/ground-realistic.webp", textureScale: 0.16, textureRotation: 0, secondaryUrl: "/textures/ground-stylized.webp", secondaryScale: 0.11, secondaryRotation: 0.82, noiseUrl: "/textures/noise-detailed.webp", noiseScale: 0.05, noiseRotation: -0.4, noiseOffset: -0.06, noiseGain: 0.9 },

  objects: [
    {
      id: "ip-works",
      kind: "building",
      label: "Machine Shop",
      position: { x: -12, z: -12 },
      size: { w: 8.81, d: 6.413, h: 5.6 },
      color: 0x6a5c4a,
      interactable: false,
      modelUrl: "/models/buildings/building_repair_shop.glb",
      rotationY: 0,
    },
    {
      id: "ip-barracks",
      kind: "building",
      label: "Site Office",
      position: { x: 16, z: -16 },
      size: { w: 13.847, d: 16.527, h: 4.4 },
      color: 0x6a5c4a,
      interactable: false,
      modelUrl: "/models/buildings/building_barracks.glb",
      rotationY: -0.4,
    },
    {
      id: "ip-shack",
      kind: "building",
      label: "Foreman Hut",
      position: { x: 22, z: 8 },
      size: { w: 5.601, d: 4.59, h: 3.2 },
      color: 0x6a5c4a,
      interactable: false,
      modelUrl: "/models/buildings/building_shack_b.glb",
      rotationY: 1.1,
    },
    {
      id: "ip-dozer",
      kind: "prop",
      label: "Stalled Bulldozer",
      position: { x: -22, z: 10 },
      size: { w: 5.4, d: 2.973, h: 2.477 },
      color: 0x6a5c4a,
      interactable: false,
      modelUrl: "/models/objects/obj_bulldozer.glb",
      rotationY: 0.9,
    },
    {
      id: "ip-tanker",
      kind: "prop",
      label: "Tanker Trailer",
      position: { x: 4, z: -26 },
      size: { w: 9, d: 3.091, h: 3.381 },
      color: 0x6a5c4a,
      interactable: false,
      modelUrl: "/models/objects/obj_trailer-tanker.glb",
      rotationY: 1.57,
    },
    {
      id: "ip-water",
      kind: "prop",
      label: "Water Tank",
      position: { x: -26, z: -22 },
      size: { w: 2.904, d: 2.795, h: 3.6 },
      color: 0x6a5c4a,
      interactable: true,
      lootObjectId: "raid_industrial_park:ip-water",
      modelUrl: "/models/objects/obj_tank-water.glb",
      rotationY: 0,
    },
    {
      id: "industrial_park-row1-1",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: -27.745, z: -1.548 },
      size: { w: 4.4, d: 1.877, h: 1.447 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-11.glb",
      collisionW: 4.4,
      collisionD: 1.877,
      rotationY: 6.235,
    },
    {
      id: "industrial_park-row1-2",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: -27.849, z: -4.528 },
      size: { w: 4.4, d: 1.863, h: 1.429 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-12.glb",
      collisionW: 4.4,
      collisionD: 1.863,
      rotationY: 6.331,
    },
    {
      id: "industrial_park-row1-3",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: -28.333, z: -7.509 },
      size: { w: 1.881, d: 4.4, h: 1.352 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-17.glb",
      collisionW: 1.881,
      collisionD: 4.4,
      rotationY: 4.814,
    },
    {
      id: "industrial_park-row1-4",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: -27.908, z: -10.49 },
      size: { w: 1.859, d: 4.4, h: 1.408 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-36.glb",
      collisionW: 1.859,
      collisionD: 4.4,
      rotationY: 4.656,
    },
    {
      id: "industrial_park-row1-5",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: -27.788, z: -13.471 },
      size: { w: 4.4, d: 1.834, h: 1.382 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-41.glb",
      collisionW: 4.4,
      collisionD: 1.834,
      rotationY: 6.299,
    },
    {
      id: "industrial_park-row1-6",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: -27.843, z: -16.452 },
      size: { w: 1.799, d: 4.4, h: 1.494 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-48-taxi.glb",
      collisionW: 1.799,
      collisionD: 4.4,
      rotationY: 4.821,
    },
    {
      id: "industrial_park-row2-1",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 25.978, z: 20.003 },
      size: { w: 4.6, d: 1.962, h: 1.512 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-11.glb",
      collisionW: 4.6,
      collisionD: 1.962,
      rotationY: 4.333,
    },
    {
      id: "industrial_park-row2-2",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 28.042, z: 14.688 },
      size: { w: 4.6, d: 1.948, h: 1.494 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-12.glb",
      collisionW: 4.6,
      collisionD: 1.948,
      rotationY: 4.337,
    },
    {
      id: "industrial_park-row2-3",
      kind: "prop",
      label: "Stacked Wreck",
      position: { x: 27.929, z: 14.486 },
      size: { w: 4.6, d: 1.917, h: 1.445 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-41.glb",
      rotationY: 4.256,
      noClip: true,
      positionY: 1.374,
    },
    {
      id: "industrial_park-row2-4",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 29.909, z: 9.291 },
      size: { w: 1.966, d: 4.6, h: 1.413 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-17.glb",
      collisionW: 1.966,
      collisionD: 4.6,
      rotationY: 2.683,
    },
    {
      id: "industrial_park-row2-5",
      kind: "prop",
      label: "Stacked Wreck",
      position: { x: 29.66, z: 9.3 },
      size: { w: 1.881, d: 4.6, h: 1.562 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-48-taxi.glb",
      rotationY: 2.888,
      noClip: true,
      positionY: 1.3,
    },
    {
      id: "industrial_park-row2-6",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 32.421, z: 4.163 },
      size: { w: 1.944, d: 4.6, h: 1.472 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-36.glb",
      collisionW: 1.944,
      collisionD: 4.6,
      rotationY: 2.721,
    },
    {
      id: "loot-1",
      kind: "loot",
      label: "Supply Crate",
      position: { x: 12.673, z: 12.6 },
      size: { w: 1.116, d: 1.116, h: 0.925 },
      color: 0x7a6544,
      interactable: true,
      lootObjectId: "raid_industrial_park:cache-1",
      modelUrl: "/models/objects/obj_crate-wood.glb",
      rotationY: 4.207,
    },
    {
      id: "loot-2",
      kind: "loot",
      label: "Stacked Crates",
      position: { x: -9.688, z: 9.817 },
      size: { w: 1.503, d: 1.431, h: 0.826 },
      color: 0x7a6544,
      interactable: true,
      lootObjectId: "raid_industrial_park:cache-2",
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 0.902,
    },
    {
      id: "loot-3",
      kind: "loot",
      label: "Ammo Case",
      position: { x: 25.4399, z: -17.4705 },
      size: { w: 1.226, d: 1.118, h: 0.731 },
      color: 0x7a6544,
      interactable: true,
      lootObjectId: "raid_industrial_park:cache-3",
      modelUrl: "/models/objects/obj_crates-2.glb",
      rotationY: 1.519,
    },
    {
      id: "loot-4",
      kind: "loot",
      label: "Dumped Barrel",
      position: { x: 12.399, z: -29.018 },
      size: { w: 0.996, d: 0.996, h: 1.337 },
      color: 0x7a6544,
      interactable: true,
      lootObjectId: "raid_industrial_park:cache-4",
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 0.638,
    },
    {
      id: "loot-5",
      kind: "loot",
      label: "Toolbox",
      position: { x: -10.31, z: -28.814 },
      size: { w: 0.656, d: 0.558, h: 0.517 },
      color: 0x7a6544,
      interactable: true,
      lootObjectId: "raid_industrial_park:cache-5",
      modelUrl: "/models/objects/obj_toolbox.glb",
      rotationY: 4.09,
    },
    {
      id: "loot-6",
      kind: "loot",
      label: "Supply Crate",
      position: { x: -20.9536, z: 14.8478 },
      size: { w: 1.019, d: 1.019, h: 0.844 },
      color: 0x7a6544,
      interactable: true,
      lootObjectId: "raid_industrial_park:cache-6",
      modelUrl: "/models/objects/obj_crate-wood.glb",
      rotationY: 0.142,
    },
    {
      id: "loot-7",
      kind: "loot",
      label: "Stacked Crates",
      position: { x: -8.564, z: 6.483 },
      size: { w: 1.355, d: 1.29, h: 0.745 },
      color: 0x7a6544,
      interactable: true,
      lootObjectId: "raid_industrial_park:cache-7",
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 5.438,
    },
    {
      id: "loot-8",
      kind: "loot",
      label: "Ammo Case",
      position: { x: -32.1752, z: -15.5316 },
      size: { w: 1.249, d: 1.139, h: 0.745 },
      color: 0x7a6544,
      interactable: true,
      lootObjectId: "raid_industrial_park:cache-8",
      modelUrl: "/models/objects/obj_crates-2.glb",
      rotationY: 5.79,
    },
    {
      id: "loot-9",
      kind: "loot",
      label: "Dumped Barrel",
      position: { x: -16.583, z: 2.964 },
      size: { w: 1.098, d: 1.098, h: 1.474 },
      color: 0x7a6544,
      interactable: true,
      lootObjectId: "raid_industrial_park:cache-9",
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 3.964,
    },
    {
      id: "loot-10",
      kind: "loot",
      label: "Toolbox",
      position: { x: 31.1281, z: 13.7903 },
      size: { w: 0.729, d: 0.621, h: 0.574 },
      color: 0x7a6544,
      interactable: true,
      lootObjectId: "raid_industrial_park:cache-10",
      modelUrl: "/models/objects/obj_toolbox.glb",
      rotationY: 1.931,
    },
    {
      id: "loot-11",
      kind: "loot",
      label: "Supply Crate",
      position: { x: 15.584, z: -2.247 },
      size: { w: 1.157, d: 1.157, h: 0.959 },
      color: 0x7a6544,
      interactable: true,
      lootObjectId: "raid_industrial_park:cache-11",
      modelUrl: "/models/objects/obj_crate-wood.glb",
      rotationY: 2.644,
    },
    {
      id: "industrial_park-junk-1",
      kind: "prop",
      label: "Barrel",
      position: { x: 19.191, z: 0.142 },
      size: { w: 0.588, d: 0.588, h: 0.789 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 1.835,
    },
    {
      id: "industrial_park-junk-2",
      kind: "prop",
      label: "Scrap Pile",
      position: { x: 6.117, z: -4.248 },
      size: { w: 1.187, d: 1.021, h: 0.352 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 1.249,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "industrial_park-junk-3",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: -7.433, z: 0.005 },
      size: { w: 1.609, d: 0.92, h: 0.814 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 1.581,
    },
    {
      id: "industrial_park-junk-4",
      kind: "prop",
      label: "Scrap Pile",
      position: { x: 14.749, z: 12.4 },
      size: { w: 1.268, d: 1.091, h: 0.376 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 4.077,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "industrial_park-junk-5",
      kind: "prop",
      label: "Scrap Pile",
      position: { x: 29.324, z: 1.739 },
      size: { w: 1.379, d: 1.186, h: 0.409 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 0.005,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "industrial_park-junk-6",
      kind: "prop",
      label: "Cable Spool",
      position: { x: -10.178, z: 29.997 },
      size: { w: 0.622, d: 0.524, h: 0.453 },
      color: 0x5a4d38,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 4.423,
      noClip: true,
    },
    {
      id: "industrial_park-junk-7",
      kind: "prop",
      label: "Barrel",
      position: { x: -20.103, z: -18.966 },
      size: { w: 0.748, d: 0.748, h: 1.003 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 4.438,
    },
    {
      id: "industrial_park-junk-8",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: -27.171, z: 7.868 },
      size: { w: 2.054, d: 1.855, h: 0.87 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 1.531,
    },
    {
      id: "industrial_park-junk-9",
      kind: "prop",
      label: "Cable Spool",
      position: { x: -12.12, z: 29.403 },
      size: { w: 0.621, d: 0.523, h: 0.453 },
      color: 0x5a4d38,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 4.769,
      noClip: true,
    },
    {
      id: "industrial_park-junk-10",
      kind: "prop",
      label: "Jersey Barrier",
      position: { x: 15.277, z: 4.195 },
      size: { w: 1.026, d: 2.657, h: 1.008 },
      color: 0x8a8578,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      rotationY: 3.206,
    },
    {
      id: "industrial_park-junk-11",
      kind: "prop",
      label: "Dumpster",
      position: { x: -25.522, z: 15.736 },
      size: { w: 2.226, d: 1.77, h: 1.593 },
      color: 0x3f5546,
      interactable: false,
      modelUrl: "/models/objects/obj_dumpster.glb",
      rotationY: 1.785,
    },
    {
      id: "industrial_park-junk-12",
      kind: "prop",
      label: "Jersey Barrier",
      position: { x: -11.848, z: 1.581 },
      size: { w: 0.901, d: 2.331, h: 0.885 },
      color: 0x8a8578,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      rotationY: 3.146,
    },
    {
      id: "industrial_park-junk-13",
      kind: "prop",
      label: "Cable Spool",
      position: { x: -5.271, z: 4.67 },
      size: { w: 0.453, d: 0.381, h: 0.33 },
      color: 0x5a4d38,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 3.87,
      noClip: true,
    },
    {
      id: "industrial_park-junk-14",
      kind: "prop",
      label: "Barrel",
      position: { x: -8.867, z: 3.027 },
      size: { w: 0.796, d: 0.796, h: 1.069 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 6.239,
    },
    {
      id: "industrial_park-junk-15",
      kind: "prop",
      label: "Half Barrel",
      position: { x: 11.403, z: 14.093 },
      size: { w: 0.572, d: 0.545, h: 0.522 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 1.664,
    },
    {
      id: "industrial_park-junk-16",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: -20.683, z: -3.504 },
      size: { w: 1.397, d: 0.799, h: 0.707 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 6.051,
    },
    {
      id: "industrial_park-junk-17",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 2.91, z: -11.199 },
      size: { w: 2.176, d: 1.966, h: 0.922 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 5.84,
    },
    {
      id: "industrial_park-junk-18",
      kind: "prop",
      label: "Barrel",
      position: { x: -11.67, z: -17.215 },
      size: { w: 0.77, d: 0.77, h: 1.033 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 5.876,
    },
    {
      id: "industrial_park-junk-19",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: -12.055, z: 8.356 },
      size: { w: 1.335, d: 0.763, h: 0.675 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 3.611,
    },
    {
      id: "industrial_park-junk-20",
      kind: "prop",
      label: "Crates",
      position: { x: -16.401, z: -19.146 },
      size: { w: 1.149, d: 1.094, h: 0.631 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 3.738,
    },
    {
      id: "industrial_park-junk-21",
      kind: "prop",
      label: "Jersey Barrier",
      position: { x: 15.368, z: -29.149 },
      size: { w: 0.934, d: 2.417, h: 0.917 },
      color: 0x8a8578,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      rotationY: 3.792,
    },
    {
      id: "industrial_park-junk-22",
      kind: "prop",
      label: "Scrap Pile",
      position: { x: -23.843, z: 13.431 },
      size: { w: 1.428, d: 1.228, h: 0.424 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 0.745,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "industrial_park-junk-23",
      kind: "prop",
      label: "Barrel",
      position: { x: -24.008, z: 16.976 },
      size: { w: 0.674, d: 0.674, h: 0.905 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 0.14,
    },
    {
      id: "industrial_park-junk-24",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 24.643, z: -1.728 },
      size: { w: 2.127, d: 1.921, h: 0.901 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 2.944,
    },
    {
      id: "industrial_park-junk-25",
      kind: "prop",
      label: "Half Barrel",
      position: { x: -10.866, z: 29.798 },
      size: { w: 0.545, d: 0.52, h: 0.498 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 3.468,
    },
    {
      id: "industrial_park-junk-26",
      kind: "prop",
      label: "Barrel",
      position: { x: 7.38, z: -14.127 },
      size: { w: 0.704, d: 0.704, h: 0.946 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 5.401,
    },
    {
      id: "industrial_park-junk-27",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 2.358, z: -18.982 },
      size: { w: 2.385, d: 2.154, h: 1.01 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 0.235,
    },
    {
      id: "industrial_park-junk-28",
      kind: "prop",
      label: "Crates",
      position: { x: -12.285, z: 4.656 },
      size: { w: 1.251, d: 1.191, h: 0.688 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 2.854,
    },
    {
      id: "industrial_park-junk-29",
      kind: "prop",
      label: "Crates",
      position: { x: -27.496, z: 4.978 },
      size: { w: 1.286, d: 1.224, h: 0.707 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 4.861,
    },
    {
      id: "industrial_park-junk-30",
      kind: "prop",
      label: "Crates",
      position: { x: -16.083, z: -7.092 },
      size: { w: 1.291, d: 1.229, h: 0.709 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 2.571,
    },
    {
      id: "industrial_park-junk-31",
      kind: "prop",
      label: "Half Barrel",
      position: { x: -4.036, z: 9.904 },
      size: { w: 0.566, d: 0.54, h: 0.517 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 2.685,
    },
    {
      id: "industrial_park-junk-32",
      kind: "prop",
      label: "Cable Spool",
      position: { x: -29.466, z: 9.267 },
      size: { w: 0.579, d: 0.488, h: 0.422 },
      color: 0x5a4d38,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 5.222,
      noClip: true,
    },
    {
      id: "industrial_park-junk-34",
      kind: "prop",
      label: "Crates",
      position: { x: -32.237, z: 1.059 },
      size: { w: 1.586, d: 1.51, h: 0.871 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 1.268,
    },
    {
      id: "industrial_park-junk-35",
      kind: "prop",
      label: "Cable Spool",
      position: { x: 20.075, z: 12.558 },
      size: { w: 0.549, d: 0.463, h: 0.4 },
      color: 0x5a4d38,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 4.561,
      noClip: true,
    },
    {
      id: "industrial_park-junk-36",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 9.381, z: 25.958 },
      size: { w: 1.898, d: 1.715, h: 0.804 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 1.913,
    },
    {
      id: "industrial_park-junk-37",
      kind: "prop",
      label: "Cable Spool",
      position: { x: 14.542, z: 8.075 },
      size: { w: 0.457, d: 0.385, h: 0.333 },
      color: 0x5a4d38,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 5.235,
      noClip: true,
    },
    {
      id: "industrial_park-junk-38",
      kind: "prop",
      label: "Half Barrel",
      position: { x: -18.969, z: 8.62 },
      size: { w: 0.538, d: 0.513, h: 0.491 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 4.244,
    },
    {
      id: "industrial_park-junk-39",
      kind: "prop",
      label: "Cable Spool",
      position: { x: -13.347, z: 0.734 },
      size: { w: 0.594, d: 0.501, h: 0.433 },
      color: 0x5a4d38,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 1.715,
      noClip: true,
    },
    {
      id: "industrial_park-junk-40",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 6.809, z: -18.841 },
      size: { w: 2.434, d: 2.198, h: 1.031 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 1.719,
    },
    {
      id: "industrial_park-junk-41",
      kind: "prop",
      label: "Scrap Pile",
      position: { x: -21.019, z: -21.518 },
      size: { w: 1.43, d: 1.23, h: 0.424 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 1.165,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "industrial_park-junk-42",
      kind: "prop",
      label: "Sandbags",
      position: { x: 11.21, z: -25.881 },
      size: { w: 1.766, d: 0.256, h: 0.241 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 4.807,
    },
    {
      id: "industrial_park-junk-43",
      kind: "prop",
      label: "Cable Spool",
      position: { x: 30.926, z: -10.421 },
      size: { w: 0.487, d: 0.41, h: 0.355 },
      color: 0x5a4d38,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 3.436,
      noClip: true,
    },
    {
      id: "industrial_park-junk-44",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: 20.261, z: 2.549 },
      size: { w: 1.353, d: 0.773, h: 0.684 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 5.8,
    },
    {
      id: "industrial_park-junk-45",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 12.945, z: -3.665 },
      size: { w: 2.368, d: 2.139, h: 1.003 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 1.515,
    },
    {
      id: "industrial_park-junk-46",
      kind: "prop",
      label: "Sandbags",
      position: { x: -16.775, z: 7.729 },
      size: { w: 1.888, d: 0.274, h: 0.257 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 4.959,
    },
    {
      id: "industrial_park-junk-47",
      kind: "prop",
      label: "Jersey Barrier",
      position: { x: -19.152, z: 2.293 },
      size: { w: 0.993, d: 2.57, h: 0.976 },
      color: 0x8a8578,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      rotationY: 0.938,
    },
    {
      id: "industrial_park-junk-48",
      kind: "prop",
      label: "Crates",
      position: { x: 9.395, z: 6.337 },
      size: { w: 1.535, d: 1.462, h: 0.844 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 2.166,
    },
    {
      id: "industrial_park-junk-49",
      kind: "prop",
      label: "Barrel",
      position: { x: -14.947, z: -17.016 },
      size: { w: 0.683, d: 0.683, h: 0.917 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 4.613,
    },
    {
      id: "industrial_park-junk-50",
      kind: "prop",
      label: "Barrel",
      position: { x: -17.51, z: 24.772 },
      size: { w: 0.784, d: 0.784, h: 1.053 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 5.63,
    },
    {
      id: "industrial_park-junk-51",
      kind: "prop",
      label: "Crates",
      position: { x: -5.382, z: 8.707 },
      size: { w: 1.343, d: 1.279, h: 0.738 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 2.751,
    },
    {
      id: "industrial_park-junk-52",
      kind: "prop",
      label: "Barrel",
      position: { x: 5.36, z: -8.185 },
      size: { w: 0.747, d: 0.747, h: 1.003 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 6.04,
    },
    {
      id: "industrial_park-junk-53",
      kind: "prop",
      label: "Sandbags",
      position: { x: -8.314, z: 27.378 },
      size: { w: 2.006, d: 0.291, h: 0.273 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 1.606,
    },
    {
      id: "industrial_park-junk-54",
      kind: "prop",
      label: "Crates",
      position: { x: -9.277, z: -23.994 },
      size: { w: 1.536, d: 1.462, h: 0.844 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 3.385,
    },
    {
      id: "industrial_park-junk-55",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: -22.915, z: -10.153 },
      size: { w: 1.739, d: 0.994, h: 0.879 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 5.96,
    },
    {
      id: "industrial_park-junk-56",
      kind: "prop",
      label: "Barrel",
      position: { x: 8.247, z: 9.179 },
      size: { w: 0.672, d: 0.672, h: 0.902 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 1.736,
    },
    {
      id: "industrial_park-junk-57",
      kind: "prop",
      label: "Scrap Pile",
      position: { x: -12.373, z: 26.419 },
      size: { w: 1.244, d: 1.07, h: 0.369 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 3.309,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "industrial_park-junk-58",
      kind: "prop",
      label: "Barrel",
      position: { x: 25.821, z: 11.092 },
      size: { w: 0.596, d: 0.596, h: 0.8 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 1.571,
    },
    {
      id: "industrial_park-junk-59",
      kind: "prop",
      label: "Barrel",
      position: { x: -30.437, z: 7.606 },
      size: { w: 0.665, d: 0.665, h: 0.893 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 0.338,
    },
    {
      id: "industrial_park-junk-60",
      kind: "prop",
      label: "Sandbags",
      position: { x: -19.018, z: -22.167 },
      size: { w: 1.702, d: 0.247, h: 0.232 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 5.023,
    },
    {
      id: "industrial_park-junk-61",
      kind: "prop",
      label: "Dumpster",
      position: { x: 10.264, z: -2.882 },
      size: { w: 2.116, d: 1.682, h: 1.515 },
      color: 0x3f5546,
      interactable: false,
      modelUrl: "/models/objects/obj_dumpster.glb",
      rotationY: 4.176,
    },
    {
      id: "industrial_park-junk-62",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: 20.877, z: -6.364 },
      size: { w: 1.842, d: 1.053, h: 0.932 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 0.709,
    },
    {
      id: "industrial_park-junk-63",
      kind: "prop",
      label: "Jersey Barrier",
      position: { x: -30.024, z: 3.43 },
      size: { w: 0.773, d: 2, h: 0.759 },
      color: 0x8a8578,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      rotationY: 0.097,
    },
    {
      id: "industrial_park-junk-64",
      kind: "prop",
      label: "Barrel",
      position: { x: -18.195, z: 26.873 },
      size: { w: 0.734, d: 0.734, h: 0.986 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 0.566,
    },
    {
      id: "industrial_park-junk-65",
      kind: "prop",
      label: "Dumpster",
      position: { x: 24.311, z: 2.154 },
      size: { w: 1.826, d: 1.451, h: 1.307 },
      color: 0x3f5546,
      interactable: false,
      modelUrl: "/models/objects/obj_dumpster.glb",
      rotationY: 0.885,
    },
    {
      id: "industrial_park-junk-66",
      kind: "prop",
      label: "Crates",
      position: { x: -9.059, z: -0.983 },
      size: { w: 1.561, d: 1.486, h: 0.858 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 5.236,
    },
    {
      id: "industrial_park-junk-67",
      kind: "prop",
      label: "Dumpster",
      position: { x: -31.538, z: -3.703 },
      size: { w: 2.375, d: 1.887, h: 1.699 },
      color: 0x3f5546,
      interactable: false,
      modelUrl: "/models/objects/obj_dumpster.glb",
      rotationY: 2.888,
    },
    {
      id: "industrial_park-junk-68",
      kind: "prop",
      label: "Barrel",
      position: { x: -11.766, z: -3.418 },
      size: { w: 0.749, d: 0.749, h: 1.006 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 3.042,
    },
    {
      id: "industrial_park-junk-69",
      kind: "prop",
      label: "Barrel",
      position: { x: -11.589, z: -22.706 },
      size: { w: 0.59, d: 0.59, h: 0.792 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 5.329,
    },
    {
      id: "industrial_park-junk-70",
      kind: "prop",
      label: "Scrap Pile",
      position: { x: -14.904, z: 4.656 },
      size: { w: 1.456, d: 1.252, h: 0.432 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 0.2,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "industrial_park-junk-71",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: -2.1, z: 9.814 },
      size: { w: 1.407, d: 0.804, h: 0.711 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 1.891,
    },
    {
      id: "industrial_park-junk-72",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: 3.942, z: -16.286 },
      size: { w: 1.455, d: 0.832, h: 0.736 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 1.786,
    },
    {
      id: "industrial_park-junk-73",
      kind: "prop",
      label: "Cable Spool",
      position: { x: -30.566, z: -0.221 },
      size: { w: 0.487, d: 0.41, h: 0.355 },
      color: 0x5a4d38,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 5.388,
      noClip: true,
    },
    {
      id: "industrial_park-junk-74",
      kind: "prop",
      label: "Barrel",
      position: { x: 9.324, z: 1.861 },
      size: { w: 0.603, d: 0.603, h: 0.81 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 2.025,
    },
    {
      id: "industrial_park-junk-76",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: 6.842, z: -8.293 },
      size: { w: 1.551, d: 0.887, h: 0.785 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 4.427,
    },
    {
      id: "industrial_park-junk-77",
      kind: "prop",
      label: "Half Barrel",
      position: { x: 1.387, z: -21.768 },
      size: { w: 0.471, d: 0.45, h: 0.43 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 3.46,
    },
    {
      id: "industrial_park-junk-78",
      kind: "prop",
      label: "Dumpster",
      position: { x: 29.383, z: -5.198 },
      size: { w: 2.39, d: 1.899, h: 1.71 },
      color: 0x3f5546,
      interactable: false,
      modelUrl: "/models/objects/obj_dumpster.glb",
      rotationY: 6.052,
    },
    {
      id: "industrial_park-junk-79",
      kind: "prop",
      label: "Cable Spool",
      position: { x: -6.335, z: 13.466 },
      size: { w: 0.589, d: 0.496, h: 0.429 },
      color: 0x5a4d38,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 3.023,
      noClip: true,
    },
    {
      id: "industrial_park-junk-80",
      kind: "prop",
      label: "Sandbags",
      position: { x: 24.322, z: -20.311 },
      size: { w: 1.781, d: 0.258, h: 0.243 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 4.785,
    },
    {
      id: "industrial_park-junk-81",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: 15.629, z: 8.365 },
      size: { w: 1.605, d: 0.918, h: 0.812 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 5.351,
    },
    {
      id: "industrial_park-junk-82",
      kind: "prop",
      label: "Crates",
      position: { x: -7.831, z: 14.03 },
      size: { w: 1.482, d: 1.412, h: 0.815 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 3.951,
    },
    {
      id: "industrial_park-junk-83",
      kind: "prop",
      label: "Sandbags",
      position: { x: -2.409, z: 11.633 },
      size: { w: 1.647, d: 0.239, h: 0.224 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 5.358,
    },
    {
      id: "industrial_park-junk-84",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: -23.105, z: -17.282 },
      size: { w: 1.933, d: 1.746, h: 0.819 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 2.418,
    },
    {
      id: "industrial_park-junk-85",
      kind: "prop",
      label: "Cable Spool",
      position: { x: -30.042, z: -12.34 },
      size: { w: 0.496, d: 0.418, h: 0.362 },
      color: 0x5a4d38,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 1.368,
      noClip: true,
    },
    {
      id: "industrial_park-junk-86",
      kind: "prop",
      label: "Barrel",
      position: { x: 26.199, z: -14.264 },
      size: { w: 0.63, d: 0.63, h: 0.845 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 1.793,
    },
    {
      id: "industrial_park-junk-87",
      kind: "prop",
      label: "Half Barrel",
      position: { x: 17.862, z: 3.14 },
      size: { w: 0.646, d: 0.616, h: 0.59 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 5.55,
    },
    {
      id: "industrial_park-junk-88",
      kind: "prop",
      label: "Dumpster",
      position: { x: -13.661, z: -25.813 },
      size: { w: 2.446, d: 1.944, h: 1.751 },
      color: 0x3f5546,
      interactable: false,
      modelUrl: "/models/objects/obj_dumpster.glb",
      rotationY: 2.707,
    },
    {
      id: "industrial_park-junk-89",
      kind: "prop",
      label: "Half Barrel",
      position: { x: -8.507, z: 1.744 },
      size: { w: 0.579, d: 0.552, h: 0.528 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 5.488,
    },
    {
      id: "industrial_park-junk-90",
      kind: "prop",
      label: "Sandbags",
      position: { x: 15.566, z: -0.575 },
      size: { w: 2.108, d: 0.306, h: 0.287 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 4.951,
    },
    {
      id: "industrial_park-junk-91",
      kind: "prop",
      label: "Barrel",
      position: { x: 11.072, z: 23.658 },
      size: { w: 0.661, d: 0.661, h: 0.887 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 2.277,
    },
    {
      id: "industrial_park-junk-92",
      kind: "prop",
      label: "Barrel",
      position: { x: 9.351, z: -1.377 },
      size: { w: 0.591, d: 0.591, h: 0.793 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 2.826,
    },
    {
      id: "industrial_park-junk-93",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: -9.168, z: -20.582 },
      size: { w: 1.886, d: 1.703, h: 0.799 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 4.86,
    },
    {
      id: "industrial_park-junk-94",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: -22.356, z: -2.052 },
      size: { w: 1.308, d: 0.748, h: 0.661 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 2.155,
    },
    {
      id: "industrial_park-junk-95",
      kind: "prop",
      label: "Barrel",
      position: { x: 29.742, z: 3.886 },
      size: { w: 0.668, d: 0.668, h: 0.897 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 1.629,
    },
    {
      id: "industrial_park-junk-96",
      kind: "prop",
      label: "Sandbags",
      position: { x: 19.474, z: -1.411 },
      size: { w: 1.831, d: 0.266, h: 0.249 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 1.96,
    },
    {
      id: "industrial_park-junk-97",
      kind: "prop",
      label: "Barrel",
      position: { x: 14.452, z: -25.136 },
      size: { w: 0.605, d: 0.605, h: 0.812 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 2.791,
    },
    {
      id: "industrial_park-junk-98",
      kind: "prop",
      label: "Scrap Pile",
      position: { x: 19.239, z: -4.817 },
      size: { w: 1.403, d: 1.207, h: 0.416 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 1.382,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "industrial_park-junk-99",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: 15.468, z: 27.692 },
      size: { w: 1.307, d: 0.748, h: 0.661 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 2.177,
    },
    {
      id: "industrial_park-junk-100",
      kind: "prop",
      label: "Crates",
      position: { x: 13.83, z: 2.099 },
      size: { w: 1.152, d: 1.097, h: 0.633 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 5.618,
    },
    {
      id: "industrial_park-junk-101",
      kind: "prop",
      label: "Crates",
      position: { x: 10.699, z: 7.871 },
      size: { w: 1.456, d: 1.386, h: 0.8 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 2.435,
    },
    {
      id: "industrial_park-junk-102",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: 22.171, z: 22.961 },
      size: { w: 1.383, d: 0.791, h: 0.699 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 0.139,
    },
    {
      id: "industrial_park-junk-103",
      kind: "prop",
      label: "Barrel",
      position: { x: -18.087, z: -15.65 },
      size: { w: 0.604, d: 0.604, h: 0.811 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 0.762,
    },
    {
      id: "industrial_park-junk-104",
      kind: "prop",
      label: "Sandbags",
      position: { x: -7.753, z: -15.689 },
      size: { w: 1.719, d: 0.249, h: 0.234 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 0.621,
    },
    {
      id: "industrial_park-junk-105",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: -10.361, z: 6.43 },
      size: { w: 1.374, d: 0.785, h: 0.695 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 1.054,
    },
    {
      id: "industrial_park-junk-106",
      kind: "prop",
      label: "Sandbags",
      position: { x: -13.099, z: -20.434 },
      size: { w: 1.785, d: 0.259, h: 0.243 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 4.642,
    },
    {
      id: "industrial_park-junk-107",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: -8.866, z: -3.798 },
      size: { w: 1.854, d: 1.674, h: 0.785 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 4.849,
    },
    {
      id: "industrial_park-junk-108",
      kind: "prop",
      label: "Crates",
      position: { x: -3.934, z: 15.141 },
      size: { w: 1.169, d: 1.113, h: 0.642 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 3.343,
    },
    {
      id: "industrial_park-junk-109",
      kind: "prop",
      label: "Sandbags",
      position: { x: -14.128, z: 2.672 },
      size: { w: 1.931, d: 0.28, h: 0.263 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 3.552,
    },
    {
      id: "industrial_park-junk-110",
      kind: "prop",
      label: "Barrel",
      position: { x: 28.407, z: -15.879 },
      size: { w: 0.68, d: 0.68, h: 0.912 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 0.729,
    },
    {
      id: "industrial_park-junk-111",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: -17.538, z: -2.115 },
      size: { w: 1.833, d: 1.048, h: 0.927 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 3.759,
    },
    {
      id: "industrial_park-junk-112",
      kind: "prop",
      label: "Half Barrel",
      position: { x: 2.842, z: -32.073 },
      size: { w: 0.639, d: 0.609, h: 0.583 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 5.291,
    },
    {
      id: "industrial_park-junk-113",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: -17.643, z: 13.061 },
      size: { w: 1.893, d: 1.71, h: 0.802 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 0.918,
    },
    {
      id: "industrial_park-junk-114",
      kind: "prop",
      label: "Sandbags",
      position: { x: -20.162, z: -15.647 },
      size: { w: 1.933, d: 0.28, h: 0.263 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 0.922,
    },
    {
      id: "industrial_park-junk-115",
      kind: "prop",
      label: "Scrap Pile",
      position: { x: -28.034, z: 10.75 },
      size: { w: 1.298, d: 1.116, h: 0.385 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 5.72,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "industrial_park-junk-116",
      kind: "prop",
      label: "Cable Spool",
      position: { x: 20.475, z: 13.571 },
      size: { w: 0.453, d: 0.382, h: 0.331 },
      color: 0x5a4d38,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 3.545,
      noClip: true,
    },
    {
      id: "industrial_park-junk-117",
      kind: "prop",
      label: "Barrel",
      position: { x: 12.334, z: 27.715 },
      size: { w: 0.829, d: 0.829, h: 1.112 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 6.136,
    },
    {
      id: "industrial_park-junk-118",
      kind: "prop",
      label: "Barrel",
      position: { x: -14.747, z: 28.322 },
      size: { w: 0.612, d: 0.612, h: 0.822 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 0.735,
    },
    {
      id: "industrial_park-junk-119",
      kind: "prop",
      label: "Half Barrel",
      position: { x: 22.972, z: -23.604 },
      size: { w: 0.534, d: 0.509, h: 0.487 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 3.847,
    },
    {
      id: "industrial_park-junk-120",
      kind: "prop",
      label: "Barrel",
      position: { x: -10.487, z: -6.272 },
      size: { w: 0.595, d: 0.595, h: 0.799 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 0.619,
    },
    {
      id: "industrial_park-junk-121",
      kind: "prop",
      label: "Cable Spool",
      position: { x: -18.971, z: 12.771 },
      size: { w: 0.513, d: 0.433, h: 0.374 },
      color: 0x5a4d38,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 4.412,
      noClip: true,
    },
    {
      id: "industrial_park-junk-122",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: -22.737, z: -4.079 },
      size: { w: 1.324, d: 0.757, h: 0.67 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 2.056,
    },
    {
      id: "industrial_park-junk-123",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 27.081, z: -6.595 },
      size: { w: 1.909, d: 1.724, h: 0.808 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 1.9,
    },
    {
      id: "industrial_park-junk-124",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: -17.948, z: -11.797 },
      size: { w: 2.462, d: 2.224, h: 1.043 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 0.284,
    },
    {
      id: "industrial_park-junk-125",
      kind: "prop",
      label: "Barrel",
      position: { x: 24.315, z: 3.826 },
      size: { w: 0.644, d: 0.644, h: 0.865 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 5.077,
    },
    {
      id: "industrial_park-junk-126",
      kind: "prop",
      label: "Crates",
      position: { x: 9.533, z: 29.506 },
      size: { w: 1.535, d: 1.461, h: 0.843 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 3.154,
    },
    {
      id: "industrial_park-junk-127",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: 13.996, z: -6.689 },
      size: { w: 1.683, d: 0.962, h: 0.851 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 5.341,
    },
    {
      id: "industrial_park-junk-128",
      kind: "prop",
      label: "Scrap Pile",
      position: { x: -16.878, z: -21.017 },
      size: { w: 1.552, d: 1.334, h: 0.461 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 2.09,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "industrial_park-junk-130",
      kind: "prop",
      label: "Jersey Barrier",
      position: { x: 31.966, z: -3.672 },
      size: { w: 1.055, d: 2.73, h: 1.036 },
      color: 0x8a8578,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      rotationY: 4.713,
    },
    {
      id: "industrial_park-junk-132",
      kind: "prop",
      label: "Cable Spool",
      position: { x: 8.366, z: 12.346 },
      size: { w: 0.573, d: 0.483, h: 0.418 },
      color: 0x5a4d38,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 3.608,
      noClip: true,
    },
    {
      id: "industrial_park-junk-133",
      kind: "prop",
      label: "Cable Spool",
      position: { x: -17.411, z: 4.69 },
      size: { w: 0.452, d: 0.381, h: 0.329 },
      color: 0x5a4d38,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 0.15,
      noClip: true,
    },
    {
      id: "industrial_park-junk-134",
      kind: "prop",
      label: "Crates",
      position: { x: -20.546, z: -8.605 },
      size: { w: 1.27, d: 1.209, h: 0.698 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 6.247,
    },
    {
      id: "industrial_park-junk-135",
      kind: "prop",
      label: "Scrap Pile",
      position: { x: -3.135, z: 25.083 },
      size: { w: 1.585, d: 1.363, h: 0.47 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 0.06,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "industrial_park-junk-136",
      kind: "prop",
      label: "Half Barrel",
      position: { x: -19.489, z: 26.597 },
      size: { w: 0.479, d: 0.456, h: 0.437 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 2.387,
    },
    {
      id: "industrial_park-junk-137",
      kind: "prop",
      label: "Scrap Pile",
      position: { x: -22.385, z: -23.639 },
      size: { w: 1.448, d: 1.245, h: 0.43 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 3.436,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "industrial_park-junk-138",
      kind: "prop",
      label: "Barrel",
      position: { x: -14.466, z: 27.239 },
      size: { w: 0.814, d: 0.814, h: 1.092 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 1.51,
    },
    {
      id: "industrial_park-junk-139",
      kind: "prop",
      label: "Jersey Barrier",
      position: { x: -19.314, z: -25.33 },
      size: { w: 0.855, d: 2.214, h: 0.84 },
      color: 0x8a8578,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      rotationY: 3.316,
    },
    {
      id: "industrial_park-junk-140",
      kind: "prop",
      label: "Jersey Barrier",
      position: { x: 9.298, z: 4.032 },
      size: { w: 0.993, d: 2.57, h: 0.976 },
      color: 0x8a8578,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      rotationY: 5.999,
    },
    {
      id: "industrial_park-junk-141",
      kind: "prop",
      label: "Sandbags",
      position: { x: 24.886, z: 13.973 },
      size: { w: 1.528, d: 0.222, h: 0.208 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 3.155,
    },
    {
      id: "industrial_park-junk-142",
      kind: "prop",
      label: "Barrel",
      position: { x: 7.393, z: -9.717 },
      size: { w: 0.74, d: 0.74, h: 0.993 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 1.552,
    },
    {
      id: "industrial_park-junk-143",
      kind: "prop",
      label: "Barrel",
      position: { x: 26.95, z: 0.176 },
      size: { w: 0.826, d: 0.826, h: 1.109 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 1.656,
    },
    {
      id: "industrial_park-junk-144",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: -31.892, z: 7.538 },
      size: { w: 1.603, d: 0.917, h: 0.811 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 2.548,
    },
    {
      id: "industrial_park-junk-145",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: 11.545, z: -6.165 },
      size: { w: 1.833, d: 1.048, h: 0.927 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 5.047,
    },
    {
      id: "industrial_park-junk-146",
      kind: "prop",
      label: "Barrel",
      position: { x: 0.046, z: -22.186 },
      size: { w: 0.754, d: 0.754, h: 1.012 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 5.538,
    },
    {
      id: "industrial_park-junk-147",
      kind: "prop",
      label: "Sandbags",
      position: { x: -23.599, z: 4.558 },
      size: { w: 1.505, d: 0.218, h: 0.205 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 0.402,
    },
    {
      id: "industrial_park-junk-148",
      kind: "prop",
      label: "Barrel",
      position: { x: -15.774, z: 28.799 },
      size: { w: 0.767, d: 0.767, h: 1.03 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 0.351,
    },
    {
      id: "industrial_park-junk-149",
      kind: "prop",
      label: "Scrap Pile",
      position: { x: 13.121, z: 29.914 },
      size: { w: 1.238, d: 1.065, h: 0.367 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 5.441,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "industrial_park-junk-150",
      kind: "prop",
      label: "Half Barrel",
      position: { x: -4.778, z: -5.935 },
      size: { w: 0.456, d: 0.435, h: 0.416 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 6.14,
    },
    {
      id: "industrial_park-junk-151",
      kind: "prop",
      label: "Half Barrel",
      position: { x: -6.462, z: -13.474 },
      size: { w: 0.459, d: 0.438, h: 0.419 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 6.238,
    },
    {
      id: "industrial_park-junk-152",
      kind: "prop",
      label: "Barrel",
      position: { x: 25.913, z: 0.904 },
      size: { w: 0.656, d: 0.656, h: 0.88 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 1.709,
    },
    {
      id: "industrial_park-junk-153",
      kind: "prop",
      label: "Half Barrel",
      position: { x: 14.435, z: 23.539 },
      size: { w: 0.475, d: 0.453, h: 0.434 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 2.584,
    },
    {
      id: "industrial_park-junk-154",
      kind: "prop",
      label: "Crates",
      position: { x: 17.546, z: 9.211 },
      size: { w: 1.415, d: 1.347, h: 0.777 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 5.539,
    },
    {
      id: "industrial_park-junk-155",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 24.209, z: -7.382 },
      size: { w: 2.113, d: 1.909, h: 0.895 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 3.475,
    },
    {
      id: "industrial_park-junk-156",
      kind: "prop",
      label: "Barrel",
      position: { x: 28.034, z: 7.105 },
      size: { w: 0.633, d: 0.633, h: 0.85 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 5.354,
    },
    {
      id: "industrial_park-junk-157",
      kind: "prop",
      label: "Scrap Pile",
      position: { x: -7.029, z: -3.045 },
      size: { w: 1.643, d: 1.413, h: 0.488 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 1.784,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "industrial_park-junk-158",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: -18.827, z: 5.084 },
      size: { w: 2.475, d: 2.236, h: 1.048 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 2.669,
    },
    {
      id: "industrial_park-junk-159",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: -10.144, z: -27.201 },
      size: { w: 2.47, d: 2.231, h: 1.046 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 5.936,
    },
    {
      id: "industrial_park-junk-160",
      kind: "prop",
      label: "Half Barrel",
      position: { x: -23.663, z: -20.159 },
      size: { w: 0.519, d: 0.495, h: 0.473 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 4.337,
    },
    {
      id: "industrial_park-junk-161",
      kind: "prop",
      label: "Barrel",
      position: { x: 17.024, z: 14.665 },
      size: { w: 0.642, d: 0.642, h: 0.862 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 3.683,
    },
    {
      id: "industrial_park-junk-162",
      kind: "prop",
      label: "Barrel",
      position: { x: -16.428, z: 10.861 },
      size: { w: 0.782, d: 0.782, h: 1.049 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 1.534,
    },
    {
      id: "industrial_park-junk-163",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: 27.445, z: 3.172 },
      size: { w: 1.795, d: 1.027, h: 0.908 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 2.675,
    },
    {
      id: "industrial_park-junk-164",
      kind: "prop",
      label: "Barrel",
      position: { x: -9.942, z: -17.114 },
      size: { w: 0.606, d: 0.606, h: 0.813 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 2.189,
    },
    {
      id: "industrial_park-junk-165",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: -13.356, z: 12.766 },
      size: { w: 2.42, d: 2.185, h: 1.025 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 3.73,
    },
    {
      id: "industrial_park-junk-166",
      kind: "prop",
      label: "Crates",
      position: { x: -29.333, z: 5.52 },
      size: { w: 1.415, d: 1.347, h: 0.778 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 4.914,
    },
    {
      id: "industrial_park-junk-167",
      kind: "prop",
      label: "Half Barrel",
      position: { x: -13.638, z: 29.518 },
      size: { w: 0.626, d: 0.597, h: 0.572 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 2.436,
    },
    {
      id: "industrial_park-junk-168",
      kind: "prop",
      label: "Jersey Barrier",
      position: { x: -12.434, z: 15.753 },
      size: { w: 0.913, d: 2.362, h: 0.897 },
      color: 0x8a8578,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      rotationY: 1.338,
    },
    {
      id: "industrial_park-junk-170",
      kind: "prop",
      label: "Crates",
      position: { x: 6.969, z: 12.983 },
      size: { w: 1.375, d: 1.31, h: 0.756 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 4.724,
    },
    {
      id: "industrial_park-junk-171",
      kind: "prop",
      label: "Half Barrel",
      position: { x: -19.801, z: -17.557 },
      size: { w: 0.467, d: 0.445, h: 0.426 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 4.275,
    },
    {
      id: "industrial_park-junk-172",
      kind: "prop",
      label: "Cable Spool",
      position: { x: 1.925, z: -16.733 },
      size: { w: 0.52, d: 0.438, h: 0.379 },
      color: 0x5a4d38,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 4.148,
      noClip: true,
    },
    {
      id: "industrial_park-junk-174",
      kind: "prop",
      label: "Barrel",
      position: { x: -13.927, z: 10.118 },
      size: { w: 0.619, d: 0.619, h: 0.831 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 2.702,
    },
    {
      id: "industrial_park-junk-175",
      kind: "prop",
      label: "Scrap Pile",
      position: { x: 11.448, z: 11.444 },
      size: { w: 1.553, d: 1.335, h: 0.461 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 0.176,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "industrial_park-junk-176",
      kind: "prop",
      label: "Half Barrel",
      position: { x: 12.285, z: 9.004 },
      size: { w: 0.595, d: 0.568, h: 0.543 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 6.14,
    },
    {
      id: "industrial_park-junk-177",
      kind: "prop",
      label: "Crates",
      position: { x: 24.816, z: -13.955 },
      size: { w: 1.452, d: 1.382, h: 0.798 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 5.206,
    },
    {
      id: "industrial_park-junk-178",
      kind: "prop",
      label: "Jersey Barrier",
      position: { x: -14.883, z: -4.038 },
      size: { w: 1.065, d: 2.757, h: 1.047 },
      color: 0x8a8578,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      rotationY: 2.211,
    },
    {
      id: "industrial_park-junk-179",
      kind: "prop",
      label: "Cable Spool",
      position: { x: -20.447, z: -17.795 },
      size: { w: 0.499, d: 0.42, h: 0.364 },
      color: 0x5a4d38,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 1.515,
      noClip: true,
    },
    {
      id: "industrial_park-junk-180",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 28.211, z: -14.229 },
      size: { w: 2.417, d: 2.183, h: 1.024 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 1.149,
    },
    {
      id: "industrial_park-junk-181",
      kind: "prop",
      label: "Crates",
      position: { x: 0.235, z: -20.17 },
      size: { w: 1.375, d: 1.309, h: 0.756 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 6.178,
    },
    {
      id: "industrial_park-junk-182",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: -14.715, z: -19.135 },
      size: { w: 2.192, d: 1.98, h: 0.928 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 6.055,
    },
    {
      id: "industrial_park-junk-183",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: -22.099, z: 2.934 },
      size: { w: 2.491, d: 2.25, h: 1.055 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 3.187,
    },
    {
      id: "industrial_park-junk-184",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: -6.451, z: 25.73 },
      size: { w: 1.361, d: 0.779, h: 0.689 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 5.044,
    },
    {
      id: "industrial_park-junk-185",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 12.538, z: 26.076 },
      size: { w: 2.145, d: 1.937, h: 0.908 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 0.112,
    },
    {
      id: "industrial_park-junk-186",
      kind: "prop",
      label: "Barrel",
      position: { x: 22.998, z: 1.115 },
      size: { w: 0.815, d: 0.815, h: 1.094 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 6.017,
    },
    {
      id: "industrial_park-junk-187",
      kind: "prop",
      label: "Half Barrel",
      position: { x: -22.603, z: -13.112 },
      size: { w: 0.637, d: 0.607, h: 0.581 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 3.85,
    },
    {
      id: "industrial_park-junk-188",
      kind: "prop",
      label: "Half Barrel",
      position: { x: -24.874, z: -0.218 },
      size: { w: 0.634, d: 0.604, h: 0.578 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 4.992,
    },
    {
      id: "industrial_park-junk-189",
      kind: "prop",
      label: "Barrel",
      position: { x: 32.85, z: 0.74 },
      size: { w: 0.762, d: 0.762, h: 1.023 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 0.841,
    },
    {
      id: "industrial_park-junk-190",
      kind: "prop",
      label: "Half Barrel",
      position: { x: -16.138, z: -24.309 },
      size: { w: 0.491, d: 0.468, h: 0.448 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 0.469,
    },
    {
      id: "industrial_park-junk-191",
      kind: "prop",
      label: "Dumpster",
      position: { x: -12.256, z: -5.088 },
      size: { w: 1.817, d: 1.444, h: 1.3 },
      color: 0x3f5546,
      interactable: false,
      modelUrl: "/models/objects/obj_dumpster.glb",
      rotationY: 1.692,
    },
    {
      id: "industrial_park-junk-192",
      kind: "prop",
      label: "Half Barrel",
      position: { x: -25.519, z: 10.785 },
      size: { w: 0.636, d: 0.607, h: 0.581 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 2.402,
    },
    {
      id: "industrial_park-junk-193",
      kind: "prop",
      label: "Crates",
      position: { x: 18.088, z: 11.017 },
      size: { w: 1.435, d: 1.367, h: 0.789 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 5.583,
    },
    {
      id: "industrial_park-junk-194",
      kind: "prop",
      label: "Jersey Barrier",
      position: { x: -14.977, z: -22.119 },
      size: { w: 0.941, d: 2.435, h: 0.924 },
      color: 0x8a8578,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      rotationY: 5.855,
    },
    {
      id: "industrial_park-junk-195",
      kind: "prop",
      label: "Scrap Pile",
      position: { x: -17.559, z: -8.446 },
      size: { w: 1.305, d: 1.123, h: 0.387 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 5.85,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "industrial_park-junk-196",
      kind: "prop",
      label: "Sandbags",
      position: { x: 24.203, z: -11.192 },
      size: { w: 1.823, d: 0.264, h: 0.248 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 3.149,
    },
    {
      id: "industrial_park-junk-197",
      kind: "prop",
      label: "Barrel",
      position: { x: 16.742, z: 22.993 },
      size: { w: 0.668, d: 0.668, h: 0.897 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 5.572,
    },
    {
      id: "industrial_park-junk-198",
      kind: "prop",
      label: "Barrel",
      position: { x: 4.991, z: 9.619 },
      size: { w: 0.762, d: 0.762, h: 1.022 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 0.526,
    },
    {
      id: "industrial_park-junk-199",
      kind: "prop",
      label: "Cable Spool",
      position: { x: -11.946, z: 5.842 },
      size: { w: 0.469, d: 0.395, h: 0.342 },
      color: 0x5a4d38,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 4.828,
      noClip: true,
    },
    {
      id: "industrial_park-junk-201",
      kind: "prop",
      label: "Barrel",
      position: { x: 22.629, z: 2.77 },
      size: { w: 0.672, d: 0.672, h: 0.903 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 2.424,
    },
    {
      id: "industrial_park-junk-202",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: 1.044, z: -31.692 },
      size: { w: 1.39, d: 0.795, h: 0.703 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 1.586,
    },
    {
      id: "industrial_park-junk-203",
      kind: "prop",
      label: "Cable Spool",
      position: { x: 16.581, z: 11.386 },
      size: { w: 0.476, d: 0.401, h: 0.347 },
      color: 0x5a4d38,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 5.893,
      noClip: true,
    },
    {
      id: "industrial_park-junk-204",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: -17.271, z: -25.429 },
      size: { w: 1.713, d: 0.98, h: 0.866 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 3.099,
    },
    {
      id: "industrial_park-junk-205",
      kind: "prop",
      label: "Barrel",
      position: { x: -24.783, z: -12.259 },
      size: { w: 0.771, d: 0.771, h: 1.035 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 5.294,
    },
    {
      id: "industrial_park-junk-206",
      kind: "prop",
      label: "Barrel",
      position: { x: 27.181, z: -17.636 },
      size: { w: 0.601, d: 0.601, h: 0.807 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 5.45,
    },
    {
      id: "industrial_park-junk-207",
      kind: "prop",
      label: "Barrel",
      position: { x: -7.346, z: 6.262 },
      size: { w: 0.668, d: 0.668, h: 0.897 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 0.94,
    },
    {
      id: "industrial_park-junk-208",
      kind: "prop",
      label: "Cable Spool",
      position: { x: -26.35, z: -19.191 },
      size: { w: 0.493, d: 0.415, h: 0.359 },
      color: 0x5a4d38,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 0.825,
      noClip: true,
    },
    {
      id: "industrial_park-junk-209",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: 17.159, z: -28.081 },
      size: { w: 1.618, d: 0.925, h: 0.818 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 2.025,
    },
    {
      id: "industrial_park-junk-210",
      kind: "prop",
      label: "Half Barrel",
      position: { x: -5.632, z: 14.737 },
      size: { w: 0.593, d: 0.565, h: 0.541 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 6.056,
    },
    {
      id: "industrial_park-junk-211",
      kind: "prop",
      label: "Barrel",
      position: { x: 14.761, z: 25.199 },
      size: { w: 0.61, d: 0.61, h: 0.819 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 0.199,
    },
    {
      id: "industrial_park-junk-212",
      kind: "prop",
      label: "Crates",
      position: { x: 28.883, z: 5.473 },
      size: { w: 1.397, d: 1.33, h: 0.768 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 4.354,
    },
    {
      id: "industrial_park-junk-213",
      kind: "prop",
      label: "Barrel",
      position: { x: 6.645, z: 15.764 },
      size: { w: 0.657, d: 0.657, h: 0.882 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 4.029,
    },
    {
      id: "industrial_park-junk-214",
      kind: "prop",
      label: "Cable Spool",
      position: { x: 21.512, z: -9.301 },
      size: { w: 0.476, d: 0.401, h: 0.347 },
      color: 0x5a4d38,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 0.38,
      noClip: true,
    },
    {
      id: "industrial_park-junk-215",
      kind: "prop",
      label: "Half Barrel",
      position: { x: 8.623, z: -23.769 },
      size: { w: 0.518, d: 0.494, h: 0.473 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 0.471,
    },
    {
      id: "industrial_park-junk-216",
      kind: "prop",
      label: "Crates",
      position: { x: -15.253, z: -28.125 },
      size: { w: 1.458, d: 1.389, h: 0.801 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 4.561,
    },
    {
      id: "industrial_park-junk-217",
      kind: "prop",
      label: "Half Barrel",
      position: { x: 21.135, z: 22.471 },
      size: { w: 0.542, d: 0.517, h: 0.494 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 3.728,
    },
    {
      id: "industrial_park-junk-218",
      kind: "prop",
      label: "Scrap Pile",
      position: { x: 26.199, z: -8.844 },
      size: { w: 1.443, d: 1.241, h: 0.428 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 0.815,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "industrial_park-junk-219",
      kind: "prop",
      label: "Cable Spool",
      position: { x: -18.707, z: -6.155 },
      size: { w: 0.524, d: 0.441, h: 0.382 },
      color: 0x5a4d38,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 4.351,
      noClip: true,
    },
    {
      id: "industrial_park-junk-220",
      kind: "prop",
      label: "Crates",
      position: { x: 25.877, z: 7.006 },
      size: { w: 1.504, d: 1.432, h: 0.827 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 2.955,
    },
  ],

  collisionZones: [
    {
      id: "edge-n",
      label: "Ridge",
      position: { x: 0, z: -37 },
      size: { w: 80, d: 2 },
    },
    {
      id: "edge-s",
      label: "Ridge",
      position: { x: 0, z: 37 },
      size: { w: 80, d: 2 },
    },
    {
      id: "edge-w",
      label: "Ridge",
      position: { x: -39, z: 0 },
      size: { w: 2, d: 76 },
    },
    {
      id: "edge-e",
      label: "Ridge",
      position: { x: 39, z: 0 },
      size: { w: 2, d: 76 },
    },
    {
      id: "fog-1",
      label: "Low Fog",
      position: { x: 28.78, z: 5.64 },
      size: { w: 17.346587780863047, d: 16.817854028195143 },
      blocksVision: true,
      blocksMovement: false,
      fog: { color: 9078135, opacity: 0.32, height: 3 },
    },
    {
      id: "fog-2",
      label: "Low Fog",
      position: { x: 14.1, z: 6.87 },
      size: { w: 15.30421794578433, d: 17.408329263329506 },
      blocksVision: true,
      blocksMovement: false,
      fog: { color: 9078135, opacity: 0.32, height: 3 },
    },
    {
      id: "fog-3",
      label: "Low Fog",
      position: { x: 23.74, z: -20.08 },
      size: { w: 18.5570569653064, d: 16.913384037092328 },
      blocksVision: true,
      blocksMovement: false,
      fog: { color: 9078135, opacity: 0.32, height: 3 },
    },
  ],

  roads: [
    {
      id: "ip-haul",
      label: "Haul Road",
      surface: "asphalt_old",
      points: [{ x: -36, z: 22 }, { x: 34, z: 18 }],
      width: 5.576,
      opacity: 0.6,
    },
    {
      id: "ip-yard",
      label: "Yard Track",
      surface: "dirt_road",
      points: [{ x: 6, z: 32 }, { x: -6, z: -30 }],
      width: 4.592,
      opacity: 0.6,
    },
  ],

  npcs: {
  },

  dialog: {
  },
};
